// Логотип авиакомпании; если картинки нет — место остаётся пустым
import { logoUrl } from '../lib';

export function AirlineLogo({ code, size = 32 }: { code: string; size?: number }) {
  return (
    <img
      src={logoUrl(code, size)}
      width={size}
      height={size}
      alt=""
      loading="lazy"
      decoding="async"
      onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
    />
  );
}
